import {
  faDownload as DownloadIcon,
  faRotate as RefreshIcon
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  TextField
} from '@mui/material';
import { useColorScheme } from '@mui/material/styles';

import useCloudSourceForm from '../../CloudSourceHooks/useCloudSourceForm.hooks';
import useStyles from '../../SourceCreate.styles';
import { shouldShowCertificateControls } from '../authenticationVisibility.utils';

/**
 * Certificate controls component.
 * Provides download and regenerate functionality for existing certificates.
 * Only shown in Edit mode for Microsoft sources with certificate authentication.
 */
const CertificateControls = () => {
  const { mode: themeMode } = useColorScheme();
  const {
    mode,
    selectedSourceTypeId,
    authenticationMode,
    regenerateCertificate,
    downladCertificate,
    regenerate
  } = useCloudSourceForm();

  const { classes } = useStyles({ themeMode });

  if (
    !shouldShowCertificateControls(
      mode,
      selectedSourceTypeId,
      authenticationMode,
      regenerateCertificate
    )
  ) {
    return null;
  }

  return (
    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
      <InputLabel htmlFor="device-name-input">Certificate Files</InputLabel>
      <FormControl className={classes.widthFull}>
        <div style={{ display: 'flex' }}>
          <TextField
            className={classes.downloadRefreshFile}
            placeholder="Certificate Files"
          />
          <IconButton
            className={classes.downloadFileBtn}
            onClick={() => downladCertificate()}
          >
            <FontAwesomeIcon icon={DownloadIcon} size="sm" />
          </IconButton>
          <IconButton
            className={classes.refreshBtn}
            onClick={() => regenerate()}
          >
            <FontAwesomeIcon icon={RefreshIcon} size="sm" />
          </IconButton>
        </div>
      </FormControl>
    </Grid>
  );
};

export default CertificateControls;
